(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('newsLast', NewsLast)

    /** @ngInject */
    function NewsLast($rootScope, HelperService, NewsService, PATHS, DATA_EVENTS) {
        function NewsLastController($scope) {
            const vm = this;

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            init();

            function getInformatives() {
                HelperService.startLoading('.last-elements.informatives');

                vm.isLoading = true;

                NewsService
                    .getAllByParameters({
                        PerPage: 11,
                        Skip: 0,
                        Active: true,
                        OrderBy: 'RegistrationDate',
                        OrderDescending: true
                    })
                    .then(success => {
                        vm.isLoading = false;
                        vm.informatives = success.Informative;
                        HelperService.stopLoading('.last-elements.informatives');
                    }, error => {
                        vm.isLoading = false;
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.last-elements.informatives');
                    })
            }

            function init() {
                vm.isLoading = true;
                vm.informatives = [];

                getInformatives();
            }
        }

        return {
            bindToController: true,
            controller: NewsLastController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/news-last/news-last.html`,
            scope: {}
        }
    }
}());